import { Outlet } from "react-router-dom";
import SideBar from "../components/SideBar/SideBar";
import Header from "../components/Header/Header";
import { useState } from "react";

const SidebarLayout: React.FC = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(() =>
    JSON.parse(localStorage.getItem("isSidebarOpen") || "true")
  );

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => {
      const newValue = !prev;
      localStorage.setItem("isSidebarOpen", JSON.stringify(newValue));
      return newValue;
    });
  };

  const styles = {
    layoutContainer: {
      display: "flex",
    },
    content: {
      flex: 1,
      marginLeft: isSidebarOpen ? "280px" : "80px",
      transition: "margin-left 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
    },
  };

  return (
    <div style={{ ...styles.layoutContainer }}>
      <SideBar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <div style={{ ...styles.content }}>
        <Header />
        <div className="main_area_inset_shadow">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default SidebarLayout;
